import React from 'react'
import { BillRatesMain } from './components/BillRatesMain'
import { BillRatesProvider } from './context/BillRatesProvider'
import { BillRatesWorkflowsProvider } from './context/BillRatesWorkflowsProvider'
import { CreateBillRateFlow } from './workflows/CreateBillRateFlow'
import { EditBillRateFlow } from './workflows/EditBillRateFlow'
import { DeleteBillRateFlow } from './workflows/DeleteBillRateFlow'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'

export const BillRates = () => {
  return (
    <NuqsAdapter>
      <BillRatesProvider>
        <BillRatesWorkflowsProvider>
          <BillRatesMain />
          <CreateBillRateFlow />
          <EditBillRateFlow />
          <DeleteBillRateFlow />
        </BillRatesWorkflowsProvider>
      </BillRatesProvider>
    </NuqsAdapter>
  )
}
